import { render, staticRenderFns } from "./SponsorList.vue?vue&type=template&id=1e7d0e18&"
import script from "./SponsorList.vue?vue&type=script&lang=js&"
export * from "./SponsorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports